import React from "react";

function IntroduceCardGrid({ cards = [], className = "" }) {
  if (!cards.length) return null;

  return (
    <ul className={`introduce-overview-card-grid ${className}`.trim()}>
      {cards.map((card, index) => (
        <li
          className="introduce-overview-card"
          key={card.id || index}
          style={{ "--introduce-delay": `${index * 90}ms` }}
        >
          {card.imgURL && (
            <div className="introduce-overview-card__media">
              <img src={card.imgURL} alt={card.title || ""} />
            </div>
          )}
          <div className="introduce-overview-card__body">
            {card.title && (
              <h2 style={{ color: card.textColor || undefined }}>
                {card.title}
              </h2>
            )}
            {card.description && (
              <div
                className="introduce-overview-card__description quill-content"
                dangerouslySetInnerHTML={{ __html: card.description }}
              />
            )}
          </div>
        </li>
      ))}
    </ul>
  );
}

export default IntroduceCardGrid;
